import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import i18n from 'utils/i18n'
import {
  filterTypes,
  CHECKBOX_LIST,
  SCORE,
  INTERVAL,
  SWITCHER,
  offersFiltersTitle,
  offersFiltersName,
  MULTISELECT_SWITCHER,
  RRP_INTERVAL,
  RADIO_LIST,
  ADMIN_FILTERS_KEY,
  DATE_INTERVAL,
  retailWinesFiltersKey,
  retailWinesFilterTitle,
  retailWinesFiltersName,
} from 'utils/consts'
import { ls } from '../../my-localstorage'
import { Roles } from 'utils/consts/userRoles'

export const getRetailWinesFiltersCollection = () => {
  const role = ls.getItem('wwl-role_code')

  return [
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.eShopCountryFilter),
      filterName: offersFiltersName.eShopCountryFilter,
      apiFilterName: retailWinesFiltersKey.eShopCountryFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.eShopFilter),
      filterName: offersFiltersName.eShopFilter,
      apiFilterName: retailWinesFiltersKey.eShopFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(offersFiltersTitle.eShopsBrandsFilter),
      filterName: offersFiltersName.eShopsBrandsFilter,
      apiFilterName: retailWinesFiltersKey.eShopsBrandsFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineCountryFilter),
      filterName: offersFiltersName.countryFilter,
      apiFilterName: retailWinesFiltersKey.wineCountryFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.producerFilter),
      filterName: offersFiltersName.producerFilter,
      apiFilterName: retailWinesFiltersKey.producerFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.brandFilter),
      filterName: offersFiltersName.brandFilter,
      apiFilterName: retailWinesFiltersKey.brandFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(retailWinesFilterTitle.additionalNameFilter),
      filterName: retailWinesFiltersName.additionalNameFilter,
      apiFilterName: retailWinesFiltersKey.additionalNameFilter,
    },
    ...([Roles.SUPERADMIN, Roles.MANAGER, Roles.CONTENT].includes(role)
      ? [
          {
            type: filterTypes[RADIO_LIST],
            title: i18n.t(retailWinesFilterTitle.withAdditionalNameFilter),
            filterName: retailWinesFiltersName.withAdditionalNameFilter,
            apiFilterName: retailWinesFiltersKey.withAdditionalNameFilter,
          },
        ]
      : []),
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineRegionEUFilter),
      filterName: offersFiltersName.wineRegionEUFilter,
      apiFilterName: ADMIN_FILTERS_KEY.wineRegionEUFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.nationalGITypeFilter),
      filterName: offersFiltersName.nationalGITypeFilter,
      apiFilterName: retailWinesFiltersKey.nationalGITypeFilter,
    },

    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.geoIndicationFilter),
      filterName: offersFiltersName.geoIndicationFilter,
      apiFilterName: retailWinesFiltersKey.geoIndicationFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.specialClassificationFilter),
      filterName: offersFiltersName.specialClassificationFilter,
      apiFilterName: retailWinesFiltersKey.specialClassificationFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineTypeFilter),
      filterName: offersFiltersName.wineTypeFilter,
      apiFilterName: retailWinesFiltersKey.wineTypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.wineColourFilter),
      filterName: offersFiltersName.wineColourFilter,
      apiFilterName: retailWinesFiltersKey.wineColourFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.sweetnessTypeFilter),
      filterName: offersFiltersName.sweetnessTypeFilter,
      apiFilterName: retailWinesFiltersKey.sweetnessTypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.vintageFilter),
      filterName: offersFiltersName.vintageFilter,
      apiFilterName: retailWinesFiltersKey.vintageFilter,
    },
    {
      type: filterTypes[SWITCHER],
      title: i18n.t(offersFiltersTitle.onlyLowestMerchantPriceFilter),
      filterName: offersFiltersName.onlyLowestMerchantPriceFilter,
      apiFilterName: retailWinesFiltersKey.onlyLowestMerchantPriceFilter,
    },
    {
      type: filterTypes[RRP_INTERVAL],
      title: i18n.t(offersFiltersTitle.retailPriceEshopsFilter),
      filterName: offersFiltersName.retailPriceFilter,
      apiFilterName: retailWinesFiltersKey.retailPriceFilter,
    },
    {
      type: filterTypes[RRP_INTERVAL],
      title: i18n.t(offersFiltersTitle.rrpShortNameFilter),
      filterName: offersFiltersName.rrpFilter,
      apiFilterName: retailWinesFiltersKey.rrpFilter,
    },
    {
      type: filterTypes[SCORE],
      title: i18n.t(offersFiltersTitle.wwlRatingFilter),
      filterName: offersFiltersName.wwlRatingFilter,
      apiFilterName: retailWinesFiltersKey.wwlRatingFilter,
    },
    {
      type: filterTypes[MULTISELECT_SWITCHER],
      title: i18n.t(offersFiltersTitle.grapesFilter),
      filterName: offersFiltersName.grapesFilter,
      apiFilterName: retailWinesFiltersKey.grapesFilter,
      switchType: filterTypes[SWITCHER],
      switchFilterName: offersFiltersName.monocepageFilter,
      switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
      switchApiFilterName: retailWinesFiltersKey.monocepageFilter,
    },
    {
      type: filterTypes[INTERVAL],
      title: i18n.t(offersFiltersTitle.alcoholLevelFilter),
      filterName: offersFiltersName.alcoholLevelFilter,
      apiFilterName: retailWinesFiltersKey.alcoholLevelFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.certificatesFilter),
      filterName: offersFiltersName.certificatesFilter,
      apiFilterName: retailWinesFiltersKey.certificatesFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.bottleSizeFilter),
      filterName: offersFiltersName.bottleSizeFilter,
      apiFilterName: retailWinesFiltersKey.bottleSizeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(offersFiltersTitle.packageTypeFilter),
      filterName: offersFiltersName.packageTypeFilter,
      apiFilterName: retailWinesFiltersKey.packageTypeFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(offersFiltersTitle.hasBottleImageFilter),
      filterName: offersFiltersName.hasBottleImageFilter,
      apiFilterName: retailWinesFiltersKey.hasBottleImageFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(offersFiltersTitle.hasFrontLabelImageFilter),
      filterName: offersFiltersName.hasFrontLabelImageFilter,
      apiFilterName: retailWinesFiltersKey.hasFrontLabelImageFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(offersFiltersTitle.hasBackLabelImageFilter),
      filterName: offersFiltersName.hasBackLabelImageFilter,
      apiFilterName: retailWinesFiltersKey.hasBackLabelImageFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(offersFiltersTitle.hasVerifiedRepresentativeFilter),
      filterName: offersFiltersName.hasVerifiedRepresentativeFilter,
      apiFilterName: retailWinesFiltersKey.hasVerifiedRepresentativeFilter,
    },
    {
      type: filterTypes[RADIO_LIST],
      title: i18n.t(retailWinesFilterTitle.priceChangeTypeFilter),
      filterName: retailWinesFiltersName.priceChangeTypeFilter,
      apiFilterName: retailWinesFiltersKey.priceChangeTypeFilter,
    },
    {
      type: filterTypes[DATE_INTERVAL],
      title: i18n.t(retailWinesFilterTitle.priceChangedAtFilter),
      filterName: retailWinesFiltersName.priceChangedAtFilter,
      apiFilterName: retailWinesFiltersKey.priceChangedAtFilter,
      fixedToDate: new Date(),
    },
  ]
}

export const retailWinesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getRetailWinesFiltersCollection,
  pathToStore: ['retail'],
  filtersDataPath: ['tradeOfferLotsFilters'],
  showResultsTextKey: 'filters.button.apply',
}
